/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ChapterUserProgressBase
 * auto generated base class for the model ChapterUserProgressModel.
 */
export const ChapterUserProgressModelBase = ModelBase.named('ChapterUserProgress')
  .props({
    __typename: types.optional(types.literal('ChapterUserProgress'), 'ChapterUserProgress'),
    _id: types.identifier,
    chapterId: types.union(types.undefined, types.string),
    completed: types.union(types.undefined, types.boolean),
    createdAt: types.union(types.undefined, types.frozen()),
    currentPosition: types.union(types.undefined, types.number),
    lessonId: types.union(types.undefined, types.frozen()),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen()),
    visibility: types.union(types.undefined, types.boolean)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ChapterUserProgressModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get chapterId() {
    return this.__attr('chapterId')
  }
  get completed() {
    return this.__attr('completed')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get currentPosition() {
    return this.__attr('currentPosition')
  }
  get lessonId() {
    return this.__attr('lessonId')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
  get visibility() {
    return this.__attr('visibility')
  }
}
export function selectFromChapterUserProgress() {
  return new ChapterUserProgressModelSelector()
}

export const chapterUserProgressModelPrimitives =
  selectFromChapterUserProgress()._id.chapterId.completed.createdAt.currentPosition.lessonId.updatedAt.userId.visibility
